import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { GALLERY } from "@/mock";

const GalleryPreview = () => {
  const items = GALLERY.slice(0, 4);
  return (
    <section
      data-testid="gallery-preview"
      className="py-24 lg:py-32 bg-brand-bg"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-8 mb-16 items-end">
          <div className="lg:col-span-7">
            <p className="text-xs font-bold uppercase tracking-[0.24em] text-brand-cta mb-4 flex items-center gap-3">
              <span className="block w-10 h-px bg-brand-cta" />
              Recent Work
            </p>
            <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter text-brand-ink leading-[0.95]">
              Before & after, <br />
              <span className="italic font-light">no filters.</span>
            </h2>
          </div>
          <div className="lg:col-span-5 lg:text-right">
            <Link
              to="/gallery"
              data-testid="gallery-preview-cta"
              className="inline-flex items-center gap-3 text-sm font-bold uppercase tracking-[0.16em] text-brand-ink border-b border-brand-ink hover:text-brand-cta hover:border-brand-cta pb-1 transition-colors"
            >
              Browse the full gallery
              <ArrowUpRight className="w-4 h-4" strokeWidth={2} />
            </Link>
          </div>
        </div>

        {/* Asymmetric grid */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 lg:gap-6">
          {items.map((g, i) => {
            const layouts = [
              "md:col-span-8 md:row-span-2 aspect-[16/10]",
              "md:col-span-4 aspect-[4/5]",
              "md:col-span-4 aspect-[4/5]",
              "md:col-span-12 aspect-[21/9]",
            ];
            return (
              <Link
                to="/gallery"
                key={g.id}
                data-testid={`gallery-preview-${g.id}`}
                className={`${layouts[i]} group relative overflow-hidden bg-brand-ink block`}
              >
                <img
                  src={g.after}
                  alt={g.title}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-brand-ink/90 via-transparent to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-6 lg:p-8 flex justify-between items-end gap-4">
                  <div>
                    <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-brand-cta mb-2">
                      {g.category} · {g.location}
                    </p>
                    <h3 className="font-heading text-xl lg:text-2xl font-bold tracking-tight text-white">
                      {g.title}
                    </h3>
                  </div>
                  <ArrowUpRight
                    className="w-5 h-5 text-white opacity-0 group-hover:opacity-100 transition-opacity"
                    strokeWidth={2}
                  />
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default GalleryPreview;
